export type ItemNameToIdMap = {
  [itemName: string]: string;
};

export const itemNameToId = {
  "Rabadon's Deathcap": '3089',
  "Yun Tal Wildarrows": "3032",
  "Chainlaced Crushers": '3173',
  "Armored Advance": '3174',
  "Crimson Lucidity": '3171',
  "Swiftmarch": '3170',
  "Energized": '2015',
  "Dusk and Dawn": '2510',
  "Actualizer": '2522',
  'Protoplasm Harness': '2525',
  "Bandlepipes": '2524',
  "Hexoptics C44": '2523',
  "Bastionbreaker": '2520',
  "Whispering Circlet": '2526',
  "Stormrazor": "3097",
  "Diadem of Songs": '2530',
  "Endless Hunger": "2517",
  "Fiendhunter Bolts": "2512",
  "Profane Hydra": '6698',
  'Trinity Force': '3078',
  'Infinity Edge': '3031',
  'Ravenous Hydra': '3074',
  'Titanic Hydra': '3748',
  'Navori Flickerblade': '6675',
  "Zhonya's Hourglass": '3157',
  'Guardian Angel': '3026',
  'Blade of the Ruined King': '3153',
  'Shadowflame': '4645',
  "Death's Dance": '6333',
  "Jak'Sho, The Protean": '6665',
  "Serylda's Grudge": '6694',
  "Warmog's Armor": '3083',
  'Lich Bane': '3100',
  "Banshee's Veil": '3102',
  'Spear of Shojin': '3161',
  'Sundered Sky': '6610',
  'Stridebreaker': '6631',
  "Archangel's Staff": '3003',
  'Mortal Reminder': '3033',
  "Lord Dominik's Regards": '3036',
  "Sterak's Gage": '3053',
  'Black Cleaver': '3071',
  'Experimental Hexplate': '3073',
  'Heartsteel': '3084',
  'Statikk Shiv': '3087',
  'Rapid Firecannon': '3094',
  "Nashor's Tooth": '3115',
  "Guinsoo's Rageblade": '3124',
  'Void Staff': '3135',
  'Mercurial Scimitar': '3139',
  'Hullbreaker': '3181',
  'Terminus': '3302',
  'Essence Reaver': '3508',
  'Cosmic Drive': '4629',
  'Riftmaker': '4633',
  'Silvermere Dawn': '6035',
  "Liandry's Torment": '6653',
  "Luden's Companion": '6655',
  'Kraken Slayer': '6672',
  'Immortal Shieldbow': '6673',
  'The Collector': '6676',
  'Axiom Arc': '6696',
  'Hubris': '6697',
  'Kaenic Rookern': '2504',
  'Manamune': '3004',
  'Spirit Visage': '3065',
  "Dead Man's Plate": '3742',
  'Stormsurge': '4646',
  'Voltaic Cyclosword': '6699',
  'Cryptbloom': '3137',
  'Unending Despair': '2502',
  'Phantom Dancer': '3046',
  "Runaan's Hurricane": '3085',
  "Wit's End": '3091',
  'Malignance': '3118',
  'Maw of Malmortius': '3156',
  'Edge of Night': '3814',
  'Force of Nature': '4401',
  'Chempunk Chainsword': '6609',
  'Hollow Radiance': '6664',
  'Eclipse': '6692',
  'Sunfire Aegis': '3068',
  'Thornmail': '3075',
  "Youmuu's Ghostblade": '3142',
  "Randuin's Omen": '3143',
  'Horizon Focus': '4628',
  'Dawncore': '6621',
  'Opportunity': '6701',
  "Rylai's Crystal Scepter": '3116',
  'Umbral Glaive': '3179',
  'Rod of Ages': '6657',
  'Iceborn Gauntlet': '6662',
  'Hextech Rocketbelt': '3152',
  "Serpent's Fang": '6695',
  "Anathema's Chains": '8001',
  'Trailblazer': '3002',
  "Winter's Approach": '3119',
  'Fimbulwinter': '3121',
  'Abyssal Mask': '8020',
  'Redemption': '3107',
  'Frozen Heart': '3110',
  "Mikael's Blessing": '3222',
  'Ardent Censer': '3504',
  'Imperial Mandate': '4005',
  'Vigilant Wardstone': '4643',
  'Staff of Flowing Water': '6616',
  "Shurelya's Battlesong": '2065',
  "Zeke's Convergence": '3050',
  "Knight's Vow": '3109',
  'Morellonomicon': '3165',
  'Locket of the Iron Solari': '3190',
  'Moonstone Renewer': '6617',
  'Echoes of Helia': '6620',
  'Chemtech Putrifier': '3011',
  "Mejai's Soulstealer": '3041',
  'Celestial Opposition': '3869',
  'Dream Maker': '3870',
  "Zaz'Zak's Realmspike": '3871',
  'Solstice Sleigh': '3876',
  'Bloodsong': '3877',
  'Verdant Barrier': '4632',
  "Seeker's Armguard": '2420',
  'Last Whisper': '3035',
  'The Brutalizer': '2020',
  'Quicksilver Sash': '3140',
  'Haunting Guise': '3147',
  'Hexdrinker': '3155',
  'Catalyst of Aeons': '3803',
  'Noonquiver': '6670',
  "Spectre's Cowl": '3211',
  'Steel Sigil': '2019',
  'Hearthbound Axe': '3051',
  'Tiamat': '3077',
  'Lost Chapter': '3802',
  'Tunneler': '2021',
  'Phage': '3044',
  'Zeal': '3086',
  "Caulfield's Warhammer": '3133',
  'Hextech Alternator': '3145',
  'Blighting Jewel': '4630',
  'Watchful Wardstone': '4638',
  'Sheen': '3057',
  "Warden's Mail": '3082',
  'Serrated Dirk': '3134',
  'Bandleglass Mirror': '4642',
  "Bami's Cinder": '6660',
  "Giant's Belt": '1011',
  'Vampiric Scepter': '1053',
  'Negatron Cloak': '1057',
  'Glacial Buckler': '3024',
  'Fiendish Codex': '3108',
  'Rectrix': '6690',
  'Aether Wisp': '3113',
  'Chain Vest': '1031',
  'Winged Moonplate': '3066',
  'Kindlegem': '3067',
  'Bramble Vest': '3076',
  'Forbidden Idol': '3114',
  "Executioner's Calling": '3123',
  'Crystalline Bracer': '3801',
  'Oblivion Orb': '3916',
  'Recurve Bow': '1043',
  'B. F. Sword': '1038',
  'Needlessly Large Rod': '1058',
  'Pickaxe': '1037',
  'Blasting Wand': '1026',
  'Cloak of Agility': '1018',
  'Null-Magic Mantle': '1033',
  'Ruby Crystal': '1028',
  'Amplifying Tome': '1052',
  'Sapphire Crystal': '1027',
  'Long Sword': '1036',
  'Rejuvenation Bead': '1006',
  'Cloth Armor': '1029',
  'Dagger': '1042',
  'Faerie Charm': '1004',
  'Glowing Mote': '2022',
  "Doran's Shield": '1054',
  "Doran's Blade": '1055',
  'Cull': '1083',
  'Scorchclaw Pup': '1101',
  'Gustwalker Hatchling': '1102',
  'Mosstomper Seedling': '1103',
  "Doran's Ring": '1056',
  'Tear of the Goddess': '3070',
  'World Atlas': '3865',
  'Dark Seal': '1082',
  'Boots': '1001',
  "Berserker's Greaves": '3006',
  'Boots of Swiftness': '3009',
  'Ionian Boots of Lucidity': '3158',
  'Plated Steelcaps': '3047',
  "Mercury's Treads": '3111',
  'Mobility Boots': '3117',
  "Sorcerer's Shoes": '3020',
  "Scout's Slingshot": '3144',
  "Fated Ashes": '2508',
  "Blackfire Torch": '2503',
  "Bloodthirster": '3072',
  "Gunmetal Greaves": '3172',
  "Bloodletter's Curse": '8010',
  };


export const itemIdToName = {
  '2512': "Fiendhunter Bolts",
  '3032': "Yun Tal Wildarrows",
  '3089': "Rabadon's Deathcap",
  '3173': "Chainlaced Crushers",
  '3171': "Crimson Lucidity",
  "3172": "Gunmetal Greaves",
  '3170': "Swiftmarch",
  '3174': "Armored Advance",
  '3072': 'Bloodthirster',
  '2522': 'Actualizer',
  '2526': 'Whispering Circlet',
  '2530': 'Diadem of Songs',
  '2517': 'Endless Hunger',
  '2510': 'Dusk and Dawn',
  '2524': 'Bandlepipes',
  '2523': 'Hexoptics C44',
  '2520': 'Bastionbreaker',
  '6698': 'Profane Hydra',
  '3078': 'Trinity Force',
  '3031': 'Infinity Edge',
  '3074': 'Ravenous Hydra',
  '3748': 'Titanic Hydra',
  '6675': 'Navori Flickerblade',
  '3157': "Zhonya's Hourglass",
  '3026': 'Guardian Angel',
  '3153': 'Blade of the Ruined King',
  '4645': 'Shadowflame',
  '6333': "Death's Dance",
  '6665': "Jak'Sho, The Protean",
  '6694': "Serylda's Grudge",
  '3083': "Warmog's Armor",
  '3097': 'Stormrazor',
  '3100': 'Lich Bane',
  '3102': "Banshee's Veil",
  '3161': 'Spear of Shojin',
  '6610': 'Sundered Sky',
  '6631': 'Stridebreaker',
  '3003': "Archangel's Staff",
  '3033': 'Mortal Reminder',
  '3036': "Lord Dominik's Regards",
  '3053': "Sterak's Gage",
  '3071': 'Black Cleaver',
  '3073': 'Experimental Hexplate',
  '3084': 'Heartsteel',
  '3087': 'Statikk Shiv',
  '3094': 'Rapid Firecannon',
  '3115': "Nashor's Tooth",
  '3124': "Guinsoo's Rageblade",
  '3135': 'Void Staff',
  '3139': 'Mercurial Scimitar',
  '3181': 'Hullbreaker',
  '3302': 'Terminus',
  '3508': 'Essence Reaver',
  '4629': 'Cosmic Drive',
  '4633': 'Riftmaker',
  '6035': 'Silvermere Dawn',
  '6653': "Liandry's Torment",
  '6655': "Luden's Companion",
  '6672': 'Kraken Slayer',
  '6673': 'Immortal Shieldbow',
  '6676': 'The Collector',
  '6696': 'Axiom Arc',
  '6697': 'Hubris',
  '2504': 'Kaenic Rookern',
  '3004': 'Manamune',
  '3065': 'Spirit Visage',
  '3742': "Dead Man's Plate",
  '4646': 'Stormsurge',
  '6699': 'Voltaic Cyclosword',
  '3137': 'Cryptbloom',
  '2502': 'Unending Despair',
  '3046': 'Phantom Dancer',
  '3085': "Runaan's Hurricane",
  '3091': "Wit's End",
  '3118': 'Malignance',
  '3156': 'Maw of Malmortius',
  '3814': 'Edge of Night',
  '4401': 'Force of Nature',
  '6609': 'Chempunk Chainsword',
  '6664': 'Hollow Radiance',
  '6692': 'Eclipse',
  '3068': 'Sunfire Aegis',
  '3075': 'Thornmail',
  '3142': "Youmuu's Ghostblade",
  '3143': "Randuin's Omen",
  '4628': 'Horizon Focus',
  '6621': 'Dawncore',
  '6701': 'Opportunity',
  '3116': "Rylai's Crystal Scepter",
  '3179': 'Umbral Glaive',
  '6657': 'Rod of Ages',
  '6662': 'Iceborn Gauntlet',
  '3152': 'Hextech Rocketbelt',
  '6695': "Serpent's Fang",
  '8001': "Anathema's Chains",
  '3002': 'Trailblazer',
  '3119': "Winter's Approach",
  '3121': 'Fimbulwinter',
  '8020': 'Abyssal Mask',
  '3107': 'Redemption',
  '3110': 'Frozen Heart',
  '3222': "Mikael's Blessing",
  '3504': 'Ardent Censer',
  '4005': 'Imperial Mandate',
  '4643': 'Vigilant Wardstone',
  '6616': 'Staff of Flowing Water',
  '2065': "Shurelya's Battlesong",
  '3050': "Zeke's Convergence",
  '3109': "Knight's Vow",
  '3165': 'Morellonomicon',
  '3190': 'Locket of the Iron Solari',
  '6617': 'Moonstone Renewer',
  '6620': 'Echoes of Helia',
  '3011': 'Chemtech Putrifier',
  '3041': "Mejai's Soulstealer",
  '3869': 'Celestial Opposition',
  '3870': 'Dream Maker',
  '3871': "Zaz'Zak's Realmspike",
  '3876': 'Solstice Sleigh',
  '3877': 'Bloodsong',
  '4632': 'Verdant Barrier',
  '2420': "Seeker's Armguard",
  '3035': 'Last Whisper',
  '2020': 'The Brutalizer',
  '3140': 'Quicksilver Sash',
  '3147': 'Haunting Guise',
  '3155': 'Hexdrinker',
  '3803': 'Catalyst of Aeons',
  '6670': 'Noonquiver',
  '3211': "Spectre's Cowl",
  '2019': 'Steel Sigil',
  '3051': 'Hearthbound Axe',
  '3077': 'Tiamat',
  '3802': 'Lost Chapter',
  '2021': 'Tunneler',
  '3044': 'Phage',
  '3086': 'Zeal',
  '3133': "Caulfield's Warhammer",
  '3145': 'Hextech Alternator',
  '4630': 'Blighting Jewel',
  '4638': 'Watchful Wardstone',
  '3057': 'Sheen',
  '3082': "Warden's Mail",
  '3134': 'Serrated Dirk',
  '4642': 'Bandleglass Mirror',
  '6660': "Bami's Cinder",
  '1011': "Giant's Belt",
  '1053': 'Vampiric Scepter',
  '1057': 'Negatron Cloak',
  '3024': 'Glacial Buckler',
  '3108': 'Fiendish Codex',
  '6690': 'Rectrix',
  '3113': 'Aether Wisp',
  '1031': 'Chain Vest',
  '3066': 'Winged Moonplate',
  '3067': 'Kindlegem',
  '3076': 'Bramble Vest',
  '3114': 'Forbidden Idol',
  '3123': "Executioner's Calling",
  '3801': 'Crystalline Bracer',
  '3916': 'Oblivion Orb',
  '1043': 'Recurve Bow',
  '2015': 'Energized',
  '1038': 'B. F. Sword',
  '1058': 'Needlessly Large Rod',
  '1037': 'Pickaxe',
  '1026': 'Blasting Wand',
  '1018': 'Cloak of Agility',
  '1033': 'Null-Magic Mantle',
  '1028': 'Ruby Crystal',
  '1052': 'Amplifying Tome',
  '1027': 'Sapphire Crystal',
  '1036': 'Long Sword',
  '1006': 'Rejuvenation Bead',
  '1029': 'Cloth Armor',
  '1042': 'Dagger',
  '1004': 'Faerie Charm',
  '2022': 'Glowing Mote',
  '1054': "Doran's Shield",
  '1055': "Doran's Blade",
  '1083': 'Cull',
  '1101': 'Scorchclaw Pup',
  '1102': 'Gustwalker Hatchling',
  '1103': 'Mosstomper Seedling',
  '1056': "Doran's Ring",
  '3070': 'Tear of the Goddess',
  '3865': 'World Atlas',
  '1082': 'Dark Seal',
  '1001': 'Boots',
  '3006': "Berserker's Greaves",
  '3009': 'Boots of Swiftness',
  '3158': 'Ionian Boots of Lucidity',
  '3047': 'Plated Steelcaps',
  '3111': "Mercury's Treads",
  '3117': 'Mobility Boots',
  '3020': "Sorcerer's Shoes",
  '3144': "Scout's Slingshot",
  '2508': "Fated Ashes",
  '2503': "Blackfire Torch",
  '8010': "Bloodletter's Curse",
};